import getConfig from 'next/config';
import { Action } from 'redux';
import axios from '../../../../utils/secured-axios';
import * as T from '../../../types/merchants/services';
import * as $ from '../../../../components/merchants/calendar/helper';

const { publicRuntimeConfig } = getConfig();

// Types of Action
export enum Types {
  Load = 'merchant/services/Load',
  SwitchViewStyle = 'merchant/services/page/SwitchViewStyle',
  Init = 'merchant/services/page/Init',
  MovePrev = 'merchant/services/page/movePrev',
  MoveNext = 'merchant/services/page/moveNext',
  ScrollNext = 'merchant/services/page/scrollNext',
}

// Action and ActionCreator

// Init
export interface InitAction extends Action {
  type: Types.Init;
  payload: {
    publicId: T.PublicId;
    timeZone: string;
  };
}

export const init = (publicId: T.PublicId, timeZone: string): InitAction => {
  return {
    payload: { publicId, timeZone },
    type: Types.Init,
  };
};

// LoadAction
export interface LoadAction extends Action {
  type: Types.Load;
  payload: {
    meta?: T.Meta;
    services: T.Service[];
    fetchedUntil: string;
  };
}

export const load = async (
  publicId: T.PublicId,
  baseDate: string,
  fetchedUntil: string,
): Promise<LoadAction | void> => {
  const fetchStartDate = $.nextFetchStartDate(fetchedUntil);
  const fetchEndDate = $.nextFetchEndDate(baseDate);

  // if services in next date range already have fetched,
  if (fetchStartDate > fetchEndDate) {
    return {
      type: Types.Load,
      payload: {
        services: [],
        fetchedUntil,
      },
    };
  }

  return axios
    .get<T.ResponseData>(
      `${
        publicRuntimeConfig.apiUrl
      }/api/v2/merchants/${publicId}/booking_events?start=${fetchStartDate.toISO()}&end=${fetchEndDate.toISO()}`,
    )
    .then(res => {
      return {
        type: Types.Load,
        payload: {
          meta: res.data.meta,
          services: res.data.data,
          fetchedUntil: fetchEndDate.toISO(),
        },
      };
    });
};

// SwitchViewStyle
export interface SwitchViewStyleAction extends Action {
  type: Types.SwitchViewStyle;
  payload: {
    viewStyle: T.ViewStyle;
  };
}

export const switchViewStyle = (
  viewStyle: T.ViewStyle,
): SwitchViewStyleAction => {
  return {
    payload: { viewStyle },
    type: Types.SwitchViewStyle,
  };
};

// MovePrev
export interface MovePrevAction extends Action {
  type: Types.MovePrev;
}

export const movePrev = (): MovePrevAction => {
  return {
    type: Types.MovePrev,
  };
};

// MoveNext
export interface MoveNextAction extends Action {
  type: Types.MoveNext;
}

export const moveNext = (): MoveNextAction => {
  return {
    type: Types.MoveNext,
  };
};

// ScrollNext
export interface ScrollNextAction extends Action {
  type: Types.ScrollNext;
}

export const scrollNext = (): ScrollNextAction => {
  return {
    type: Types.ScrollNext,
  };
};

// Composing
export type Actions =
  | LoadAction
  | SwitchViewStyleAction
  | InitAction
  | MovePrevAction
  | MoveNextAction
  | ScrollNextAction;

export const ActionsCreators = {
  load,
  switchViewStyle,
  init,
  movePrev,
  moveNext,
  scrollNext,
};
